module.exports = __webpack_public_path__ + "img/b-victoriaans.6a28e2a0.jpg";